import React from 'react';

const EditIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.973"
      height="10.973"
      viewBox="0 0 10.973 10.973"
    >
      <g
        id="Group_981"
        data-name="Group 981"
        transform="translate(-201 -433.36)"
      >
        <g
          id="Group_704"
          data-name="Group 704"
          transform="translate(201 434.144)"
        >
          <g id="Group_703" data-name="Group 703">
            <path
              id="Path_2393"
              data-name="Path 2393"
              d="M9.014,38.84a.392.392,0,0,0-.392.392v3.919a.392.392,0,0,1-.392.392H1.176a.392.392,0,0,1-.392-.392V35.313a.392.392,0,0,1,.392-.392h4.7a.392.392,0,1,0,0-.784h-4.7A1.176,1.176,0,0,0,0,35.313v7.838a1.176,1.176,0,0,0,1.176,1.176H8.23a1.176,1.176,0,0,0,1.176-1.176V39.232A.392.392,0,0,0,9.014,38.84Z"
              transform="translate(0 -34.137)"
              fill={color || '#f5f5f5'}
            />
          </g>
        </g>
        <g
          id="Group_706"
          data-name="Group 706"
          transform="translate(203.352 433.36)"
        >
          <g id="Group_705" data-name="Group 705" transform="translate(0 0)">
            <path
              id="Path_2394"
              data-name="Path 2394"
              d="M110.591.443a1.5,1.5,0,0,0-2.122,0l-5.162,5.162a.4.4,0,0,0-.094.153l-.784,2.351a.392.392,0,0,0,.372.516.4.4,0,0,0,.124-.02l2.351-.784a.392.392,0,0,0,.153-.095l5.162-5.162A1.5,1.5,0,0,0,110.591.443Zm-.554,1.568-5.095,5.095-1.522.508.507-1.52L109.023,1a.716.716,0,1,1,1.013,1.012Z"
              transform="translate(-102.409 -0.004)"
              fill={color || '#f5f5f5'}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EditIcon;
